export default __webpack_public_path__ + "static/media/underline.ecba4c44.svg";